import { useNavigate } from 'react-router-dom';

function AdminLeads() {
    const navigate = useNavigate();

    return (
        <div className="container text-center">
            <h2 className="mt-4">Admin Leads</h2>
            <div className="d-flex justify-content-center mt-5 flex-wrap">
                <div
                    onClick={() => navigate('/admin/leads/list')}
                    className="modal-new-sequence-item"
                    style={{ width: '260px', height: '180px' }}>
                    <div className="my-auto">
                        <i className="fas fa-list fa-4x ulysses-primary"></i>
                        <div className="bold mt-3">List Leads</div>
                    </div>
                </div>
                <div
                    onClick={() => navigate('/admin/leads/upload')}
                    className="modal-new-sequence-item"
                    style={{ width: '260px', height: '180px' }}>
                    <div className="my-auto">
                        <i className="fas fa-upload fa-4x ulysses-primary"></i>
                        <div className="bold mt-3">Upload Leads</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLeads;
